// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3ded7","label":"LabeledBox_label__eMomq"};